import React, { useEffect, useState } from "react";
import cn from "classnames";
import SVG from "src/utils/SVG";
import styled from "styled-components";

interface IFulfillProp {
  data?: any;
}

const NoticeFulfillList = (props: IFulfillProp) => {
  const [exeRateData, setExeRateData] = useState<any>([]);
  const [exeScoreData, setExeScoreData] = useState<any>([]);

  useEffect(() => {
    if (props.data) {
      setExeRateData(props.data.data.getProfileNoticeTotalCountAsStore);
      setExeScoreData(props.data.data.profileNoticeRate);
    }
  }, [props.data]);

  return (
    <NoticeFulfillDash>
      <>
        {exeRateData && (
          <div>
            <dt>이행률</dt>
            <dd className="flex-box">
              <p>
                <span>{exeRateData.executeRate ? exeRateData.executeRate : 0}</span>%
              </p>
              <p>
                {exeRateData.execute_count ? exeRateData.execute_count : 0} / {exeRateData.total_count ? exeRateData.total_count : 0}
              </p>
            </dd>
          </div>
        )}
        {exeScoreData && (
          <div>
            <dt>별점</dt>
            <dd>
              <div className={cn("score", { disabled: exeScoreData.score === null })}>
                <SVG name="star" width={20} height={20} viewBox="0 0 20 20" />
                <span>{exeScoreData.score >= 0 && exeScoreData.score !== null ? exeScoreData.score : "-"}</span>
              </div>
            </dd>
          </div>
        )}
      </>
    </NoticeFulfillDash>
  );
};

const NoticeFulfillDash = styled.dl`
  padding: 10px 0 4px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-around", "center")}
  > div {
    position: relative;
    ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "flex-start")}
    flex: 1;
    height: 45px;
    padding-left: 18px;
    margin-left: 15px;
    color: ${({ theme }) => theme.color.secondary};
    font-size: 14px;
    text-align: left;
    dt {
      margin-bottom: 3px;
      font-size: 12px;
      font-weight: 500;
      text-transform: uppercase;
    }
    dd {
      color: #000;
      &.flex-box {
        ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-end")}
        > p {
          &:first-child {
            > span {
              font-family: "Poppins";
              font-size: 18px;
              font-weight: 500;
              line-height: 20px;
            }
          }
          &:last-child {
            margin-left: 16px;
            color: ${({ theme }) => theme.color.secondary};
          }
        }
      }
      .score {
        > svg {
          position: relative;
          top: -1px;
        }
        > span {
          margin-left: 4px;
        }
      }
    }
    &:first-child {
      margin-left: 0;
    }
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      display: inline-block;
      width: 1.5px;
      height: 100%;
      border-radius: 3px;
      background-color: #8c96aa;
    }
  }
`;

export default NoticeFulfillList;
